import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import Relay from 'react-relay';
import PropTypes from 'prop-types';

import LoadingButton from "../fw/LoadingButtonNew.react";
import {defineMessages, injectIntl} from "react-intl";
import 'whatwg-fetch';
import Token from "../../../packages/extension/src/background/Token";

import {Textarea, Form} from 'formsy-react-components';
import { User } from '../../common/types/types';


const messages = defineMessages({
    query: {id: 'datiQuery.query', 'defaultMessage': 'Query'},
    title: {id: 'datiQuery.title', 'defaultMessage': 'Manual DatiQuery'},
    execute: {id: 'datiQuery.execute', 'defaultMessage': 'Execute query'},
});


interface DatiQueryToolProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}


class DatiQueryTool extends React.Component<DatiQueryToolProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();

        this.state = {
            "query": "select * from [APP \"eu.flexibee\" ENTITY \"eu.flexibee.companies\"] as current LIMIT 10",
            "error": "",
            "status": "new",
            "errorMessage": "",
        };
    }

    executeQuery = () => {
        let query = this.state.query;

        let url = document.getElementsByTagName('body').item(0).dataset.apihost + '/datiquery?query=' + encodeURIComponent(query);
        return fetch(url, {
            headers: {
                "Authorization": 'Bearer ' + Token.get(),
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            if (!json['errorMessage']) {
                json['errorMessage'] = '';
            }
            if (!json['error']) {
                json['error'] = '';
            }
            this.setState(json);
        }).catch((e) => {
            this.setState({
                errorMessage: e.message,
                status: "error",
            });
        });
    };

    render() {

        return (
            <AppPanel breadcrumbParams={[
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <Form
                    onSubmit={this.executeQuery}>
                        <div className="form-group">
                            <Textarea className="form-control" label={this.props.intl.formatMessage(messages.query)} name="query" onChange={(column, value) => { this.setState({"query": value}); }} rows={3} style={{"width": "100%"}} value={this.state.query}>
                            </Textarea>
                        </div>
                </Form>
                <LoadingButton className={"btn btn-default"} onClick={this.executeQuery} text={this.props.intl.formatMessage(messages.execute)}/>
                {this.state.status !== "new" ?
                    <div style={{paddingTop: '1em'}}>
                        {this.state.errorMessage ? <div className="error">{this.state.errorMessage}</div> : null}
                        {this.state.status === "ok" ? <div>{JSON.stringify(this.state.data)}</div> : null}
                    </div>
                    : null
                }


            </AppPanel>
        );
    }
}

export default Relay.createContainer(injectIntl(DatiQueryTool), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
            }
        `,
    },
});
